import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  APPROVAL_TABLE_HEAD_BG,
  approvalFormTableStyles,
} from '@/components/Approval/@components/ApprovalFormTable/styles';

/** V2 카드·레거시 문서 카드 모두 태그·클래스로 스타일링 */
export const ProductLifecycleRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': { ...approvalFormTableStyles(theme), minWidth: 640 },
  '& .plm-card + .plm-card, & > div + div': { marginTop: 16 },
  '& .text-center': { textAlign: 'center' },
  '& .text-right': { textAlign: 'right' },
  '& td': { verticalAlign: 'middle' },
  // 레거시 문서는 bg-title·textBold
  '& td.label, & td.bg-title': {
    fontWeight: 500,
    backgroundColor: APPROVAL_TABLE_HEAD_BG,
  },
  '& td.bg-info': {
    fontWeight: 600,
    backgroundColor: 'var(--dk-accent-soft, #EEF4FC)',
  },
  '& .plm-image img, & td[rowspan] > img': {
    display: 'block',
    width: 150,
    height: 200,
    margin: '0 auto',
    objectFit: 'contain',
  },
}));

export const PlmCardActions = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: 4,
});
